export default "__VITE_ASSET__yz5Lakga__"